//import { Component, Input } from '@angular/core';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { Observable, Subscription } from 'rxjs';
//import { SpiderChartService } from '../../spider-chart.service';
import { TableViewService } from '../../table-view.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';

HighchartsMore(Highcharts);
HighchartsAccessibility(Highcharts);

@Component({
  selector: 'app-spider-chart02',
  template: `
    <div class="spider-chart-container" [class.popup-open]="popUp" [id]="'chart-container'+id" [ngStyle]="{'height': popUp ? '30em' : (height === '11em' ? '11em' : 'calc(100% - 2rem )')}" [style]="'height:'+this.height"></div>
  `,
})
export class Spiderchart02Component {
  seriesData: any[] = [];
  ChartData: any[] = [];
  sampleSizeValues: any;
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
  changeValue: any;
  significanceValue: any;
  significanceValue2: any;
  data: any;
  chartCategories: any;
  userselectedchartdata: any;
  seriescolor: any;
  globalColorMap: { [key: string]: string } = {};
  
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "28em";
  @Input() isOutput: any;
  configuredProperties: any;
  maxDataPoints: any = 2;
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  chartMainData: any = [];
  
  ngOnInit(): void {
    // Inject the Highcharts override CSS if not already present
    const styleId = 'highcharts-axis-labels';
    if (!document.getElementById(styleId)) {
      const link = document.createElement('link');
      link.id = styleId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'assets/styles/highcharts-overrides.css';
      document.head.appendChild(link);
    }
    
    // Subscribe to global color map
    this.subscriptions.add(
      this._configService.globalColorMap$.subscribe((map) => {
        if (map) {
          this.globalColorMap = map;
          // Re-render chart if it exists to apply new colors
          if (this.chart && this.isOutput) {
            try {
              this.preparemainChartData(this.customData);
              this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample', this.chartMainData);
              this.splitLowSampleSeriesForMasking();
              this.renderChart2('chart-container' + this.id, this.data['data'], this.ChartProperties);
            } catch (e) {}
          }
        }
      })
    );
    
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      if(this.customData){
        for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
             if(this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
               this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=this.customData.customizationProperties;
             }
        }
      }
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
    }
    else{
          this.getData().subscribe(
            (jsonData: any) => {
              this.data = jsonData[0];
              this.ChartData = jsonData[0]['data'];
              this.ChartProperties = jsonData[0]["properties"][0];
              this.route.paramMap.subscribe((params) => {
                const userData = history.state.userData;
                this.userselectedchartdata = userData; // Use the userData object as needed
                if (this.userselectedchartdata?.widgetEditSelection) {
                  if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                    this.ChartProperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
                  }
                }
              });
              this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
            }
          );
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }

  constructor(private http: HttpClient, private spiderService: TableViewService,private _customSnapshotService: CustomsnapshotService,private _configService: SnapshotService,private router: Router,
    private route: ActivatedRoute) { }

  getData(): Observable<any> {
    return this.http.get<any>('assets/Data/spiderData.json');
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/spiderData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.data = data[0];
        this.ChartProperties = this.data['properties'][0];
        this.ChartProperties = this.configuredProperties != undefined ? this.configuredProperties : this.ChartProperties;
         this.seriescolor = this.spiderService.color;
        // this.seriesgradientcolor = this.piechartservice.linearGradients1;
        // this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.ChartProperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.ChartProperties.dataLabelPosition = 'right';
        this.ChartProperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.ChartProperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
      });
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option            ,
            "Rounded Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? 'NA' : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": !this._configService.multiCohort  && dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Value": dataArr.data == null ? null : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? 'NA' : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }

  seriesObject: any = {};
  accessSeriesValues(islowSample: any,data:any) {
    if(this.isOutput){
      const seriesObjects: any = {};
      const categories: string[] = [];
      let colorIndex = 0;
  
      for (const series of data) {
        const seriesName = series["Series Name"];
        const roundedValue = series["Rounded Value"];
        const Value = series["Label"];
        let numericValue = (Value === " " || Value === null || Value === 'NA') ? 0 : parseFloat(Number(Value).toFixed(this.ChartProperties.decimalRoundOff));
        let label = (series.Label);
        const change = series["Change value vs PY"] != null?parseFloat(series["Change value vs PY"]):series["Change value vs PY"];
        const significance = parseFloat(series["Significance"]);
        const category = series["Category Name"];
        const sampleSize = series["Sample size"];
        const significance2 = series["Significance2"];
        const ValueForIndex = series["ValueForIndex"];
        const ActualIndexValue = series["ActualIndexValue"];
        const Sig_LowerLimt = series["Sig_LowerLimt"];
        const Sig_UpperLimt = series["Sig_UpperLimt"];
        const isPercentage = series["isPercentage"];
        const Significance_Value = series["Significance_Value"];
        
        // Use global color map if available, otherwise use default color palette
        const legendkeycolor = this.globalColorMap && this.globalColorMap[seriesName] 
          ? this.globalColorMap[seriesName] 
          : (this.seriescolor && this.seriescolor[colorIndex] ? this.seriescolor[colorIndex] : '#000000');
  
        // Check if chartProperties.showNegative is false and series has negative values
        if (!this.ChartProperties.showNegative && numericValue < 0) {
          continue; // Skip this series
        }
  
        let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.spiderService.sampleSizeConstant ? numericValue : 0);
        let tooltip ="";
  
        if (!seriesObjects[seriesName]) {
          seriesObjects[seriesName] = {
            name: seriesName,
            data: [],
            label: [],
            changeValue: [],
            roundedValue: [],
            significanceValue: [],
            significanceValue2: [],
            sampleSizeValues: [],
            ValueForIndex:[],
            ActualIndexValue:[],
            isPercentage:[],
            Sig_UpperLimt:[],
            Sig_LowerLimt:[],
            legendkeycolor:[],
            visible: true,
            tooltip:[],
            Significance_Value:[],
            pointPlacement: 'on',
          };
        }
  
        seriesObjects[seriesName].data.push(finalvalue);
        seriesObjects[seriesName].roundedValue.push(roundedValue);
        seriesObjects[seriesName].label.push(label);
        seriesObjects[seriesName].changeValue.push(change);
        seriesObjects[seriesName].significanceValue.push(significance);
        seriesObjects[seriesName].significanceValue2.push(significance2);
        seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
        seriesObjects[seriesName].ValueForIndex.push(ValueForIndex);
        seriesObjects[seriesName].ActualIndexValue.push(ActualIndexValue);
        seriesObjects[seriesName].tooltip.push(tooltip);
        seriesObjects[seriesName].isPercentage.push(isPercentage);
        seriesObjects[seriesName].Sig_LowerLimt.push(Sig_LowerLimt);
        seriesObjects[seriesName].Sig_UpperLimt.push(Sig_UpperLimt);
        seriesObjects[seriesName].Significance_Value.push(Significance_Value);
        seriesObjects[seriesName].legendkeycolor.push(legendkeycolor);
        
        if (!categories.includes(category)) {
          categories.push(category);
        }
        colorIndex++;
      }
  
      this.seriesData = Object.values(seriesObjects).map((item: any) => {
        return {
          name: item.name,
          data: item.data,
          label: item.label,
          color: item.color,
          changeValue: item.changeValue,
          roundedValue: item.roundedValue,
          visible: item.visible,
          significanceValue: item.significanceValue,
          significanceValue2: item.significanceValue2,
          sampleSizeValues: item.sampleSizeValues,
          ActualIndexValue:item.ActualIndexValue,
          ValueForIndex:item.ValueForIndex,
          showInlegend: item.showInLegend,
          tooltip: item.tooltip,
          isPercentage:item.isPercentage,
          Sig_LowerLimt:item.Sig_LowerLimt,
          Sig_UpperLimt:item.Sig_UpperLimt,
          Significance_Value:item.Significance_Value,
          pointPlacement: 'on',
          legendkeycolor:item.legendkeycolor
        };
      });
  
      this.chartCategories = categories;
    }
    else{
        const seriesObjects: any = {};
        const categories: string[] = [];

        for (const series of data) {
          const seriesName = series["Series Name"];
          const roundedValue = series["Rounded Value"];
          let numericValue = (roundedValue === " " || roundedValue === null) ? 0 : parseFloat(Number(roundedValue).toFixed(this.ChartProperties.decimalRoundOff));
          let label = (series.Label);
          const change = series["ChangeVs"]!=null?parseFloat(series["ChangeVs"]):series["ChangeVs"];
          const significance = parseFloat(series["Significance"]);
          const category = series["Category Name"];
          const sampleSize = series["Sample size"];
          const significance2 = series["Significance2"];

          // Check if chartProperties.showNegative is false and series has negative values
          if (!this.ChartProperties.showNegative && numericValue < 0) {
            continue; // Skip this series
          }

          let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.spiderService.sampleSizeConstant ? numericValue : 0);
          let tooltip ="";

          if (!seriesObjects[seriesName]) {
            seriesObjects[seriesName] = {
              name: seriesName,
              data: [],
              label: [],
              changeValue: [],
              roundedValue: [],
              significanceValue: [],
              significanceValue2: [],
              sampleSizeValues: [],
              visible: true,
              tooltip:[],
              pointPlacement: 'on',
            };
          }

          seriesObjects[seriesName].data.push(finalvalue);
          seriesObjects[seriesName].roundedValue.push(roundedValue);
          seriesObjects[seriesName].label.push(label);
          seriesObjects[seriesName].changeValue.push(change);
          seriesObjects[seriesName].significanceValue.push(significance);
          seriesObjects[seriesName].significanceValue2.push(significance2);
          seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
          seriesObjects[seriesName].tooltip.push(tooltip);

          if (!categories.includes(category)) {
            categories.push(category);
          }
        }

        this.seriesData = Object.values(seriesObjects).map((item: any) => {
          return {
            name: item.name,
            data: item.data,
            label: item.label,
            // color: item.color,
            changeValue: item.changeValue,
            roundedValue: item.roundedValue,
            visible: item.visible,
            significanceValue: item.significanceValue,
            significanceValue2: item.significanceValue2,
            sampleSizeValues: item.sampleSizeValues,
            showInlegend: item.showInLegend,
            tooltip: item.tooltip,
            pointPlacement: 'on',
          };
        });

        this.chartCategories = categories;
    }
  }

  // customization() {
  //   return this.spiderService.customizationStack1();
  // }

  /**
   * Transform series so that low-sample points (<= threshold) do NOT contribute to a connecting line.
   * For non-superadmin users only.
   * Strategy:
   *  - For each original series S we create up to two series:
   *      a) High sample series: retains original type & lineWidth, low-sample points become null to break the path.
   *      b) Low sample marker series: lineWidth 0 (no polygon stroke), contains only low-sample points (others null) so markers & labels show.
   *  - Legend shows only the high sample series (marker series hidden).
   */
  private splitLowSampleSeriesForMasking(): void {
    const role = (this._configService.userRole || '').toLowerCase();
    if (role === 'superadmin') return; // show everything normally for superadmin
    if (!Array.isArray(this.seriesData) || this.seriesData.length === 0) return;
    const threshold = this._configService?.ISthreshold ?? this.spiderService.sampleSizeConstant;

    const transformed: any[] = [];
    this.seriesData.forEach((s: any) => {
      if (!Array.isArray(s.sampleSizeValues)) { transformed.push(s); return; }
      const highSampleData: any[] = [];
      const lowSampleData: any[] = [];
      let hasLow = false; let hasHigh = false;
      for (let i = 0; i < s.data.length; i++) {
        const ss = parseFloat(s.sampleSizeValues[i]);
        const val = s.data[i];
        if (!isNaN(ss) && ss > threshold) {
          // keep in high, null in low
            highSampleData.push(val);
            lowSampleData.push(null);
            hasHigh = true;
        } else {
          // low sample -> break line in high series
            highSampleData.push(null);
            lowSampleData.push(val); // will show marker
            hasLow = true;
        }
      }
      // Original series becomes high sample path (even if fully high)
      const highSeries = { ...s, data: highSampleData };
      transformed.push(highSeries);
      if (hasLow) {
        // Add marker-only series
        transformed.push({
          ...s,
          name: s.name + ' (IS)',
          data: lowSampleData,
          showInLegend: false,
          // Ensure no connecting stroke / fill or interaction
          type: 'line',
          lineWidth: 0,
          enableMouseTracking: false,
          // color: s.color,
          fillOpacity: 0,
          marker: { enabled: false },
          states: { hover: { enabled: false } },
          // Force dataLabels to show 'I/S' text in place of removed marker/line for each low-sample point
          dataLabels: {
            enabled: true,
            useHTML: false,
            defer: false,
            allowOverlap: true,
            padding: 0,
            style: {
              fontSize: '0.65em',
              fontWeight: 'normal',
              color: '#555',
              textOutline: 'none'
            },
            formatter: function(this: any){
              if(this.y === null || this.y === undefined) return '';
              return 'I/S';
            }
          },
        });
      }
    });
    this.seriesData = transformed;
  }

  renderChart2(container2: any, seriesdata: any, properties: any) {
    let popUp=this.popUp;
         const componentId = this.id;
    if(this.isOutput){
      localStorage.setItem("properties", JSON.stringify(properties));
      this.preparemainChartData(this.customData);
      const allNA = this.chartMainData.length === 0 || this.chartMainData.every((d: any) => d['Label'] === 'NA' || d['Label'] === null || d['Label'] === undefined);
      if (allNA) {
        const containerEl2 = document.getElementById(container2);
        if (containerEl2) { containerEl2.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>'; }
        return;
      }
      this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample',this.chartMainData);
      this.splitLowSampleSeriesForMasking();
      const configService = this._configService;
      let maxDataValue = 0;
      const numberOfTicks = 15;
      const sampleSizeConstant = this.spiderService.sampleSizeConstant;
      let chartType=this.ChartProperties.sectorfill?'area':'line';
      let height = this.height;

      // Assign colors to series using global color map first, then fallback to default palette
      this.seriesData.forEach((series, index) => {
        // Extract brand name from series name (after pipe if present)
        const brandName = series.name.includes('|') ? series.name.split('|')[1] : series.name;
        
        // Use global color map if available for this brand, otherwise use default palette
        if (this.globalColorMap && this.globalColorMap[brandName]) {
          series.color = this.globalColorMap[brandName];
        } else {
          // Fallback to gradient or regular color palette
          if (this.ChartProperties.gradient) {
            series.color = this.spiderService.color[index % this.spiderService.color.length];
          } else {
            series.color = this.spiderService.color[index % this.spiderService.color.length];
          }
        }
      });
  
      const maxArray: number[] = new Array<number>(this.seriesData[0].data.length).fill(0);
  
      // Find the maximum value at each index across all series
      this.seriesData.forEach(series => {
        series.data.forEach((value: any, index: any) => {
          maxArray[index] = Math.max(maxArray[index], value);
        });
      });
  
      // Now maxArray contains the maximum value at each index
      maxDataValue = Math.max(...maxArray);
      maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);
      const tickInterval = Math.ceil(maxDataValue / numberOfTicks);
      if(this.ChartProperties.sectorfill){
          const options: Highcharts.Options = {
            chart: {
              polar: true,
              type: this.ChartProperties.sectorfill?'area':'line',
              backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
              style: {
                fontFamily: this.spiderService.textfont,
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              }
            },
            title: {
              text: "",
              align: this.ChartProperties.chartTitlePosition,
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                marginleft: '4%',
                fontSize: '2em',
                fontFamily: this.spiderService.textfont
              }
            },
            exporting: {
              enabled: false
            },
            credits: {
              enabled: false,
            },
            legend:
            // {
            //   navigation: {
            //     itemMarginLeft: 10,
            //     activeColor: '#7f7f7f',
            //     animation: true,
            //     arrowSize: 10,
            //     inactiveColor: '#ccc',
            //     style: {
            //       fontSize: '0.7em',
            //       color: this.ChartProperties.darkTheme ? 'white' : '#333',
            //     }
            //   },
            //   // y:chartproperties.legendPosition == 'bottom'?0:4,
            //   maxHeight: this.ChartProperties.legendPosition == 'bottom' ? 45 : 300,
            //   layout:
            //   this.ChartProperties.legendPosition != 'bottom'
            //       ? 'vertical'
            //       : 'horizontal',
            //   // x: this.height == "100%" ? 50 : -20,
            //   y: this.ChartProperties.legendPosition == 'bottom' ? 10 : 0,
            //   // width: height=='100%'?100:'100%',
            //   // itemWidth: 400,
            //   align: this.ChartProperties.legendPosition,
            //   verticalAlign:
            //   this.ChartProperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
            //   symbolWidth: 0,  // Set to a valid non-negative value
            //   symbolHeight: 0, // Set to a valid non-negative value
            //   //symbolWidth: -1,
            //   //symbolHeight: -1,
            //   useHTML: true,
            //   itemMarginTop: 0,    // Adjust this value to reduce the top margin
            //   // itemMarginLeft:-50,
            //   itemMarginBottom: -5,
            //   itemStyle: {
            //     fontWeight: "normal",
            //     fontSize: '0.8em',
            //     cursor: 'pointer'
            //   },
            //   labelFormatter: function (): any {
            //     let point = this as any;
            //     let textcolor = properties.darkTheme ? 'white' : 'black';
            //     if (point.color != "#eeebed" && point.color != "#7f7f7f") {
            //       return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
            //         + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
            //         + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;font-size:0.8em;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
            //         + '</div>';
            //     }
            //   },
            // }, 
            this.spiderService.customizeLegendRadar(this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
//           xAxis: {
//   categories: this.chartCategories,
//   tickmarkPlacement: 'on',
//   lineWidth: 0,
//         labels: {
//           distance: -10, // Reduce space between label and chart
//           useHTML: true,
//           style: {
//             width: this.popUp ? '300px' : '220px',
//             minWidth: this.popUp ? '300px' : '220px',
//             maxWidth: this.popUp ? '300px' : '220px',
//             whiteSpace: 'normal',
//             textOverflow: 'ellipsis',
//             fontSize: '0.7em',
//             color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
//             fontFamily: this.spiderService.textfont
//           }
//         }
// }
// ,
xAxis: {
  categories: this.chartCategories,
  tickmarkPlacement: 'on',
  lineWidth: 0,
  labels: {
    distance: 5,
    useHTML: true,
    style: {
      maxWidth: '100px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,        // clamp to 2 lines
      WebkitBoxOrient: 'vertical',
      fontSize: '0.6em',
      textAlign: 'center',
      color: this.ChartProperties.darkTheme ? 
             this.spiderService.darkThemeTextColor : 
             this.spiderService.lightThemeTextColor,
      fontFamily: this.spiderService.textfont
    }
  }
},

            yAxis: {
              visible:  true,
              gridLineWidth: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              gridLineColor: this.ChartProperties.gridlinecolor,
              gridLineDashStyle: this.ChartProperties.gridlinestyle,
              min: 0,
              max: maxDataValue, // Adjust this value based on your data
              tickInterval: tickInterval,
              labels: {
                enabled: this.ChartProperties.axes,
                format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont
                },
              },
              gridLineStyle: {
                dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
                lineWidth: 1,  // The width of grid lines
                lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
              }
            },
            pane: {
              size: '80%'
            },
            tooltip: {
               enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',  
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },
            
              formatter:function (this: any){
                if (this.series.name === 'Marker1') return false;
                let isDefaultTooltip = "style1";//properties.toolTipStyle;
              let value = properties.showDataLabel == true
  ? this.series.userOptions.roundedValue[this.point.x]
  : this.y;
let text = value != null && value !== ''
  ? Number(value).toFixed(2)
  : value;
                let text1:any;
                if(text!=null){
                    text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
                }
                else{
                  text1=text;
                }
                const dotColor = this.series.color; // Get the series color
                const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
                const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';

                // For index mode, show the same value text as the data label (precomputed in userOptions.tooltip)
                const isIndexMode = properties.datalabelStyle === 'index';
                const precomputedLabelHtml = this.series.userOptions.tooltip && this.series.userOptions.tooltip[this.point.x] != null
                  ? this.series.userOptions.tooltip[this.point.x]
                  : null;
                const valueInline: any = isIndexMode && precomputedLabelHtml ? precomputedLabelHtml : text1;

                // Change value styling should match data label (sigClass + 1 decimal, % when applicable)
                const isPct = !!(this.series.userOptions.isPercentage && this.series.userOptions.isPercentage[this.point.x]);
                const rawChangeValue = this.series.userOptions.changeValue ? this.series.userOptions.changeValue[this.point.x] : null;
                const changeVal = (rawChangeValue == null || rawChangeValue === 'NA')
                  ? null
                  : (isPct ? (Number(rawChangeValue) * 100) : Number(rawChangeValue));

                const sigVal = this.series.userOptions.Significance_Value ? this.series.userOptions.Significance_Value[this.point.x] : null;
                const lowLim = this.series.userOptions.Sig_LowerLimt ? this.series.userOptions.Sig_LowerLimt[this.point.x] : null;
                const upLim = this.series.userOptions.Sig_UpperLimt ? this.series.userOptions.Sig_UpperLimt[this.point.x] : null;
                const sigClass = (sigVal != null && lowLim != null && upLim != null)
                  ? (sigVal < lowLim ? 'red' : (sigVal > upLim ? 'green' : 'black'))
                  : 'black';

                const isSigChangeMode = properties.datalabelStyle === 'sigChange';
                let changeDisplay = '';
                if (isSigChangeMode && !isIndexMode) {
                  if (rawChangeValue == null || rawChangeValue === 'NA') {
                    changeDisplay = `<span style="color:black; font-size: 0.9em; margin-left:4px;">(NA)</span>`;
                  } else if (changeVal != null && !isNaN(changeVal)) {
                    const formatted = parseFloat(Number(changeVal).toFixed(1)) + (isPct ? '%' : '');
                    changeDisplay = `<span style="color:${sigClass}; font-size: 0.9em; margin-left:4px;">(${formatted})</span>`;
                  }
                }

                if (isDefaultTooltip != "style1") {
                  const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.7em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${valueInline} ${changeDisplay}`;
                return commonContent + '</div>';
                }
                else {
                   const content =
    `<div class="high-z-tooltip" style="background: #fff;border:1px solid ${dotColor};border-radius:4px; min-width: 220px; font-size: 0.7em; box-shadow: none; z-index:999 !important; padding:6px;">
      <div style="display:flex; align-items:center;">
        <span style="width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; flex-shrink:0;"></span>
        <span>${this.series.name}: ${valueInline} ${changeDisplay}</span>
      </div>
    </div>`;
  return content;
                }
              }
          },
            plotOptions: {
              series:{
                
                animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
              },
              area: {
                dashStyle: this.ChartProperties.Linestyle,
                shadow: this.ChartProperties.shadow ? {
                  color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 5,
                } : false,
                marker: {
                  symbol: properties.markerStyle,
                },
                dataLabels:
                {
                  allowOverlap: this.ChartProperties.dataLabelOverlap,
                  enabled: this.ChartProperties.showDataLabel,
                  useHTML: false,
                  align: this.ChartProperties.dataLabelPosition,
                  rotation: this.ChartProperties.datalabelOrientation,
                  color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                  style: {
                    backgroundColor: 'transparent',
                    shadow: false,
                    borderWidth: 0,
                    textOutline: 'none',
                    borderRadius: 0,
                    padding: '2%',
                    fontFamily: this.spiderService.textfont,
                    fontSize: '0.8em',
                    fontWeight: "normal"
                  },
                  formatter: function (this: any) {
                    let sigcolor;
                    const upwardTriangle = '&#9650';
                    const downwardTriangle = '\u25BC';
                    const upColor = 'green';
                    const downColor = 'red';
                    let text; let finalText;
                    let changeText;
                    let sig;
                    let sColor;
      
                    properties.dataLabelFormat = this.isPercentage;
                    let textcolor = properties.dataLabelColor;
                    if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                      finalText = "NA";
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
                    if (properties.datalabelStyle == "sigchan") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = properties.darkTheme ? 'white' : 'black';
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
      
                    if (properties.datalabelStyle == "datalabel") {
                      let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                      text = textCheck != null? textCheck + (properties.datalabelFormat ? '%' : ''):'NA';
                      finalText = (
                        '<span style="font-size:'+ properties.dataLabelSize +';">' + text + '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle === 'sigChange') {
                      let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                      let changeVal = this.series.userOptions.isPercentage[this.point.x] ? (Number(this.series.userOptions.changeValue[this.point.x]) * 100) : (Number(this.series.userOptions.changeValue[this.point.x]));
                      if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                        let text = textCheck + (properties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                        this.series.userOptions.tooltip[this.point.x] = text;
                        return (
                          '<span style="color:' + textcolor + ';font-size:'+ properties.dataLabelSize +'">' + text + '</span>'
                        );
                      }
                      else {
                        let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt[this.point.x] ? 'red' : (this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt[this.point.x] ? 'green' : 'black');
                        //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                        let text = textCheck + ((properties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(this.series.userOptions.changeValue[this.point.x] != null ? parseFloat(Number(changeVal).toFixed(1)) + (properties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                        this.series.userOptions.tooltip[this.point.x] = text;
                        return (
                          '<span style="color:' + textcolor + ';font-size:'+ properties.dataLabelSize +'">' + text + '</span>'
                        );

                      }

                    }

                    if (properties.datalabelStyle === "index") {
                      let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                      text = textCheck != null? textCheck + (properties.datalabelFormat ? '%' : ''):'NA';
                      let text2 = this.series.userOptions.ActualIndexValue[this.point.x] == null ? 'NA' : this.y == -1 ? -1 : this.y != null ? this.series.userOptions.ValueForIndex[this.point.x].toFixed(1) : 'NA';

                      if (text2 == "-1" || text2 == -1) {
                        text2 = "NA";
                      }
                      let color = configService.CheckIndexColoring(String(text2));
                        this.tooltip = text + "(" + text2 + ")";
                        finalText = (
                          '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                          '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                        );
                        this.series.userOptions.tooltip[this.point.x]=finalText;
                        return finalText;
                    }
      
                    if (properties.datalabelStyle == "change") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      let changeColor = properties.darkTheme ? 'white' : 'black';
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';font-size:'+ properties.dataLabelSize +'">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == "significance") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');
      
                      finalText = (
                        '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';font-size:'+ properties.dataLabelSize +'">' + s + '</span></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == "significance2") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');
      
                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
      
                      finalText = (
                        '<span>' + text +
                        (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    if (properties.datalabelStyle == 'lowSample') {
                      text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                      finalText = (
                        '<span>' +
                        text +
                        '</span> ' +
                        '<span style="opacity: 0.5"></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
      
                    finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                }
              }
            },
            series: this.seriesData,
          } as any;
          const containerEl = document.getElementById(container2);
          if (!containerEl) { return; }
          this.chart = Highcharts.chart(containerEl, options);
      }
      else{
        const options: Highcharts.Options = {
          chart: {
            polar: true,
            type: this.ChartProperties.sectorfill?'area':'line',
            backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
            spacingTop: this.popUp ? 28 : 18,
            spacingRight: this.popUp ? 26 : 18,
            spacingBottom: this.popUp ? 30 : 20,
            spacingLeft: this.popUp ? 26 : 18,
            style: {
              fontFamily: this.spiderService.textfont,
              color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
            }
          },
          title: {
            text: "",
            align: this.ChartProperties.chartTitlePosition,
            style: {
              color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              marginleft: '4%',
              fontSize: '2em',
              fontFamily: this.spiderService.textfont
            }
          },
          exporting: {
            enabled: false
          },
          credits: {
            enabled: false,
          },
          legend: 
          // {
          //   navigation: {
          //     itemMarginLeft: 10,
          //     activeColor: '#7f7f7f',
          //     animation: true,
          //     arrowSize: 10,
          //     inactiveColor: '#ccc',
          //     style: {
          //       fontSize: '0.7em',
          //       color: this.ChartProperties.darkTheme ? 'white' : '#333',
          //     }
          //   },
          //   // y:chartproperties.legendPosition == 'bottom'?0:4,
          //   maxHeight: this.ChartProperties.legendPosition == 'bottom' ? 45 : 300,
          //   layout:
          //   this.ChartProperties.legendPosition != 'bottom'
          //       ? 'vertical'
          //       : 'horizontal',
          //   // x: this.height == "100%" ? 50 : -20,
          //   y: this.ChartProperties.legendPosition == 'bottom' ? 10 : 0,
          //   // width: height=='100%'?100:'100%',
          //   // itemWidth: 400,
          //   align: this.ChartProperties.legendPosition,
          //   verticalAlign:
          //   this.ChartProperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          //   symbolWidth: 0,  // Set to a valid non-negative value
          //   symbolHeight: 0, // Set to a valid non-negative value
          //   //symbolWidth: -1,
          //   //symbolHeight: -1,
          //   useHTML: true,
          //   itemMarginTop: 0,    // Adjust this value to reduce the top margin
          //   // itemMarginLeft:-50,
          //   itemMarginBottom: -5,
          //   itemStyle: {
          //     fontWeight: "normal",
          //     fontSize: '0.8em',
          //     cursor: 'pointer'
          //   },
          //   labelFormatter: function (): any {
          //     let point = this as any;
          //     let textcolor = properties.darkTheme ? 'white' : 'black';
          //     if (point.color != "#eeebed" && point.color != "#7f7f7f") {
          //       return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
          //         + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
          //         + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;font-size:0.8em;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
          //         + '</div>';
          //     }
          //   },
          // },
          this.spiderService.customizeLegendRadar(this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
          xAxis: {
  categories: this.chartCategories,
  tickmarkPlacement: 'on',
  lineWidth: 0,
 labels: {
          useHTML: true,  // allows custom styling
          style: {
            // width: this.popUp?'350px':'100px', // force 300px width
            // minWidth: this.popUp?'350px':'100px',
             maxWidth: this.popUp?'16em':'10em',
            whiteSpace: 'normal',
            textOverflow: 'unset',
            fontSize: this.popUp ? '0.65em' : '0.6em',  
            color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
            fontFamily: this.spiderService.textfont,
            width: 'auto !important'
          },
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              // Calculate available width per label
              const chart = this.axis.chart;
              const categories = this.axis.categories || [];
              const labelWidth = popUp ? '12em' : '8.5em';
          
              // Split label into multiple lines, fitting as many words as possible per line
              function splitLabelToTwoLines(str: string, maxWidth: string | number) {
                const words = str.split(' ');
                
                // If only one word, return as is
                if (words.length <= 1) {
                  return str;
                }
                
                // Create a temporary element to measure text width
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                if (!context) {
                  // Fallback: just return original string if canvas not available
                  return str;
                }
                
                // Set font to match the chart labels (approximate)
                context.font = '0.6em sans-serif'; // Match the fontSize from xAxis labels
                
                // Convert maxWidth to pixels if it's in em units and apply conservative factor
                let maxWidthPx: number;
                if (typeof maxWidth === 'string' && maxWidth.endsWith('em')) {
                  const emValue = parseFloat(maxWidth.replace('em', ''));
                  // Use 90% of available width to allow more text while still maintaining some padding
                 const chartElement = document.getElementById('chart-container' + componentId);
const actualFontSize = chartElement ? 
  parseFloat(getComputedStyle(chartElement).fontSize) : 16;
maxWidthPx = (emValue * actualFontSize) * 1.5;
                } else if (typeof maxWidth === 'number') {
                  // Apply conservative factor to numeric width as well
                  maxWidthPx = maxWidth * 1.5;
                } else {
                  maxWidthPx = 144; // Default fallback (10em * 16px * 0.9)
                }
                
                const lines: string[] = [];
                let currentLine = '';
                let wordIndex = 0;
                
                // Keep labels compact so neighboring axis labels don't overlap.
                const maxLines = popUp ? 4 : 3;
                
                while (wordIndex < words.length && lines.length < maxLines) {
                  const word = words[wordIndex];
                  const testLine = currentLine ? currentLine + ' ' + word : word;
                  
                  // Measure actual text width
                  const textWidth = context.measureText(testLine).width;
                  
                  if (textWidth <= maxWidthPx) {
                    // Word fits, add it to current line
                    currentLine = testLine;
                    wordIndex++;
                  } else {
                    // Word doesn't fit
                    if (currentLine) {
                      // Save current line and start new one
                      lines.push(currentLine);
                      currentLine = '';
                      
                      // Check if we've reached max lines limit
                      if (lines.length >= maxLines) {
                        // If there are remaining words and we're at the limit, add ellipsis
                        if (wordIndex < words.length) {
                          const lastLine = lines[lines.length - 1];
                          lines[lines.length - 1] = lastLine + '...';
                        }
                        break;
                      }
                    } else {
                      // Single word is too long, add it anyway
                      lines.push(word);
                      wordIndex++;
                    }
                  }
                }
                
                // Add the last line if it has content and we haven't exceeded max lines
                if (currentLine && lines.length < maxLines) {
                  lines.push(currentLine);
                } else if (currentLine && lines.length >= maxLines) {
                  // If we have remaining content but reached max lines, add ellipsis
                  const lastLine = lines[lines.length - 1];
                  lines[lines.length - 1] = lastLine + '...';
                }
                
                return lines.join('<br/>');
              }
          
              let labelContent = String(this.value);
              labelContent = splitLabelToTwoLines(labelContent, labelWidth);
          
              // Determine text alignment based on number of lines
              const textAlign = 'center';
          
              // If axisImage is enabled, show image instead
             
                // Center-align text for single line, left-align for multiple lines
                const marginStyle = 'margin: 0 auto';
                return `<div style="width:${labelWidth}; text-align: ${textAlign}; ${marginStyle}; padding: 0 2px; line-height: 1.2;" title="${String(this.value)}">${labelContent}</div>`;
              
            },
        }
}
,
          yAxis: {
            visible:  true,
            gridLineWidth: 1,
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            gridLineColor: this.ChartProperties.gridlinecolor,
            gridLineDashStyle: this.ChartProperties.gridlinestyle,
            min: 0,
            max: maxDataValue, // Adjust this value based on your data
            tickInterval: tickInterval,
            opposite: true,
            zIndex: 5,
            labels: {
              enabled: this.ChartProperties.axes,
              format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                fontFamily: this.spiderService.textfont
              },
              zIndex: 10
            },
            gridLineStyle: {
              dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
              lineWidth: 1,  // The width of grid lines
              lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
            },
          },
          pane: {
            center: ['50%', this.popUp ? '50%' : '52%'],
            size: this.popUp ? '66%' : '56%'
          },
          tooltip: {
            enabled: true,
            borderWidth: 0,
            useHTML: true,
            shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
            shadow: false,
            backgroundColor: 'rgba(0,0,0,0)',
          
            formatter:function (this: any){
              if (this.series.name === 'Marker1') return false;
              let isDefaultTooltip = "style1";//properties.toolTipStyle;
             let value = properties.showDataLabel == true
  ? this.series.userOptions.roundedValue[this.point.x]
  : this.y;
let text = value != null && value !== ''
  ? Number(value).toFixed(2)
  : value;
              let text1:any;

              if(text!=null){
                  text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
              }
              else{
                text1=text;
              }
              const dotColor = this.series.color; // Get the series color
              const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
              const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';

              // For index mode, show the same value text as the data label (precomputed in userOptions.tooltip)
              const isIndexMode = properties.datalabelStyle === 'index';
              const precomputedLabelHtml = this.series.userOptions.tooltip && this.series.userOptions.tooltip[this.point.x] != null
                ? this.series.userOptions.tooltip[this.point.x]
                : null;
              const valueInline: any = isIndexMode && precomputedLabelHtml ? precomputedLabelHtml : text1;

              // Change value styling should match data label (sigClass + 1 decimal, % when applicable)
              const isPct = !!(this.series.userOptions.isPercentage && this.series.userOptions.isPercentage[this.point.x]);
              const rawChangeValue = this.series.userOptions.changeValue ? this.series.userOptions.changeValue[this.point.x] : null;
              const changeVal = (rawChangeValue == null || rawChangeValue === 'NA')
                ? null
                : (isPct ? (Number(rawChangeValue) * 100) : Number(rawChangeValue));

              const sigVal = this.series.userOptions.Significance_Value ? this.series.userOptions.Significance_Value[this.point.x] : null;
              const lowLim = this.series.userOptions.Sig_LowerLimt ? this.series.userOptions.Sig_LowerLimt[this.point.x] : null;
              const upLim = this.series.userOptions.Sig_UpperLimt ? this.series.userOptions.Sig_UpperLimt[this.point.x] : null;
              const sigClass = (sigVal != null && lowLim != null && upLim != null)
                ? (sigVal < lowLim ? 'red' : (sigVal > upLim ? 'green' : 'black'))
                : 'black';

              const isSigChangeMode = properties.datalabelStyle === 'sigChange';
              let changeDisplay = '';
              if (isSigChangeMode && !isIndexMode) {
                if (rawChangeValue == null || rawChangeValue === 'NA') {
                  changeDisplay = `<span style="color:black; font-size: 0.9em; margin-left:4px;">(NA)</span>`;
                } else if (changeVal != null && !isNaN(changeVal)) {
                  const formatted = parseFloat(Number(changeVal).toFixed(1)) + (isPct ? '%' : '');
                  changeDisplay = `<span style="color:${sigClass}; font-size: 0.9em; margin-left:4px;">(${formatted})</span>`;
                }
              }

              if (isDefaultTooltip != "style1") {
                const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.7em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${valueInline} ${changeDisplay}`;
                return commonContent + '</div>';
              }
              else {
                 const content =
    `<div class="high-z-tooltip" style="background: #fff;border:1px solid ${dotColor};border-radius:4px; min-width: 220px; font-size: 0.7em; box-shadow: none; z-index:999 !important; padding:6px;">
      <div style="display:flex; align-items:center;">
        <span style="width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; flex-shrink:0;"></span>
        <span>${this.series.name}: ${valueInline} ${changeDisplay}</span>
      </div>
    </div>`;
  return content;
              }
            }
        },
          plotOptions: {
            series:{
              animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },

            },
            line: {
              dashStyle: this.ChartProperties.Linestyle,
              shadow: this.ChartProperties.shadow ? {
                color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 5,
              } : false,
              marker: {
                symbol: properties.markerStyle,
              },
              dataLabels:
              {
                allowOverlap: this.ChartProperties.dataLabelOverlap,
                enabled: this.ChartProperties.showDataLabel,
                align: this.ChartProperties.dataLabelPosition,
                rotation: this.ChartProperties.datalabelOrientation,
                color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                style: {
                  backgroundColor: 'transparent',
                  shadow: false,
                  borderWidth: 0,
                  textOutline: 'none',
                  borderRadius: 0,
                  padding: '2%',
                  fontFamily: this.spiderService.textfont,
                  fontSize: '0.8em',
                  fontWeight: "normal"
                },
                formatter: function (this: any) {
                  let sigcolor;
                  const upwardTriangle = '&#9650';
                  const downwardTriangle = '\u25BC';
                  const upColor = 'green';
                  const downColor = 'red';
                  let text; let finalText;
                  let changeText;
                  let sig;
                  let sColor;
    
                  properties.dataLabelFormat = this.isPercentage;
                  let textcolor = properties.dataLabelColor;
                  if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                    finalText = "NA";
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                  if (properties.datalabelStyle == "sigchan") {
                    text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    let changeColor = properties.darkTheme ? 'white' : 'black';
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    
                    finalText = (
                      '<span>' + text +
                      (changeText ? '&nbsp<span style="color:' + ';">' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
    
                  if (properties.datalabelStyle == "datalabel") {
                     let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                    text = textCheck != null? textCheck + (properties.datalabelFormat ? '%' : ''):'NA';
                    finalText = (
                      '<span style="font-size:'+ properties.dataLabelSize +';">' + text + '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }

                  if (properties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(this.y), Number(this.series.userOptions.sampleSizeValues[this.point.x]));
                    let changeVal = this.series.userOptions.isPercentage[this.point.x] ? (Number(this.series.userOptions.changeValue[this.point.x]) * 100) : (Number(this.series.userOptions.changeValue[this.point.x]));
                    if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                      let text = textCheck + (properties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      this.series.userOptions.tooltip[this.point.x] = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ properties.dataLabelSize +'">' + text + '</span>'
                      );
                    }
                    else {
                      let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt[this.point.x] ? 'red' : (this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt[this.point.x] ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let text = textCheck + ((properties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(this.series.userOptions.changeValue[this.point.x] != null ? parseFloat(Number(changeVal).toFixed(1)) + (properties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                      this.series.userOptions.tooltip[this.point.x] = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ properties.dataLabelSize +'">' + text + '</span>'
                      );

                    }

                  }

                  if (properties.datalabelStyle === "index") {
                    text = this.y != null? this.y + (properties.datalabelFormat ? '%' : ''):'NA';
                    let text2 = this.series.userOptions.ActualIndexValue[this.point.x] == null ? 'NA' : this.y == -1 ? -1 : this.y != null ? this.series.userOptions.ValueForIndex[this.point.x].toFixed(1) : 'NA';

                    if (text2 == "-1" || text2 == -1) {
                      text2 = "NA";
                    }
                    let color = configService.CheckIndexColoring(String(text2));
                      this.tooltip = text + "(" + text2 + ")";
                      finalText = (
                        '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                        '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                  }
    
                  if (properties.datalabelStyle == "change") {
                    text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    let changeColor = properties.darkTheme ? 'white' : 'black';
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    
                    finalText = (
                      '<span>' + text +
                      (changeText ? '&nbsp<span style="color:' + ';font-size:'+ properties.dataLabelSize +'">' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == "significance") {
                    text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');
    
                    finalText = (
                      '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';font-size:'+ properties.dataLabelSize +'">' + s + '</span></span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == "significance2") {
                    text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                    changeText = this.series.userOptions.changeValue[this.point.x];
                    sig = this.series.userOptions.significanceValue[this.point.x];
                    let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                    sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                    let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');
    
                    if (parseFloat(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
    
                    finalText = (
                      '<span>' + text +
                      (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  if (properties.datalabelStyle == 'lowSample') {
                    text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                    finalText = (
                      '<span>' +
                      text +
                      '</span> ' +
                      '<span style="opacity: 0.5"></span>'
                    );
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
    
                  finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  this.series.userOptions.tooltip[this.point.x]=finalText;
                  return finalText;
                }
              }
            }
          },
          series: this.seriesData,
        } as any;
        const containerEl = document.getElementById(container2);
        if (!containerEl) { return; }
        this.chart = Highcharts.chart(containerEl, options);
      }
    }
    else{
          localStorage.setItem("properties", JSON.stringify(properties));
          this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample',this.ChartData);
      this.splitLowSampleSeriesForMasking();
          let maxDataValue = 0;
          const numberOfTicks = 15;
          const sampleSizeConstant = this.spiderService.sampleSizeConstant;

          if (this.ChartProperties.gradient) {
            this.seriesData.forEach((series, index) => {
              series.color = this.spiderService.customColors1[index % this.spiderService.customColors1.length]; // Assign colors from customColors1
            });
          }
          else {
            this.seriesData.forEach((series, index) => {
              series.color = this.spiderService.customColors[index % this.spiderService.customColors.length]; // Assign colors from customColors2
            });
          }

          const maxArray: number[] = new Array<number>(this.seriesData[0].data.length).fill(0);

          // Find the maximum value at each index across all series
          this.seriesData.forEach(series => {
            series.data.forEach((value: any, index: any) => {
              maxArray[index] = Math.max(maxArray[index], value);
            });
          });

          // Now maxArray contains the maximum value at each index
          maxDataValue = Math.max(...maxArray);
          maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);
          const tickInterval = Math.ceil(maxDataValue / numberOfTicks);

          const options: Highcharts.Options = {
            chart: {
              polar: true,
              type: 'line',
              backgroundColor: this.ChartProperties.darkTheme ? this.spiderService.darkThemebg : this.spiderService.lightThemebg,
              style: {
                fontFamily: this.spiderService.textfont,
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
              }
            },
            title: {
              text: "",
              align: this.ChartProperties.chartTitlePosition,
              style: {
                color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                marginleft: '4%',
                fontSize: '2em',
                fontFamily: this.spiderService.textfont
              }
            },
            exporting: {
              enabled: false
            },
            credits: {
              enabled: false,
            },
            legend: this.spiderService.customizeLegendRadar(this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
          xAxis: {
  categories: this.chartCategories,
  tickmarkPlacement: 'on',
  lineWidth: 0,
  labels: {
    useHTML: true,  // allows custom styling
    style: {
      width: '120px',   // increase width for full text
      whiteSpace: 'normal', // wrap instead of truncating
      textOverflow: 'unset', 
      color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
      fontFamily: this.spiderService.textfont
    }
  }
},

            yAxis: {
              visible:  true,
              gridLineWidth: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              gridLineColor: this.ChartProperties.gridlinecolor,
              gridLineDashStyle: this.ChartProperties.gridlinestyle,
              min: 0,
              max: maxDataValue, // Adjust this value based on your data
              tickInterval: tickInterval,
              labels: {
                enabled: false,
                format: this.ChartProperties.datalabelFormat == "number" ? '{value}' : '{value}%',
                style: {
                  color: this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor,
                  fontFamily: this.spiderService.textfont
                },
              },
              gridLineStyle: {
                dashStyle: 'dot',  // 'solid', 'dot', 'dash', etc.
                lineWidth: 1,  // The width of grid lines
                lineColor: this.ChartProperties.gridlinecolor,  // Color for grid lines
              }
            },
            pane: {
              size: '80%'
            },
            tooltip: {
              enabled: true,
              borderWidth: 0,
              useHTML: true,
              shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
              shadow: false,
              backgroundColor: 'rgba(0,0,0,0)',
            
              formatter:function (this: any){
                if (this.series.name === 'Marker1') return false;
                let isDefaultTooltip = "style1";//properties.toolTipStyle;
              let value = properties.showDataLabel == true
  ? this.series.userOptions.roundedValue[this.point.x]
  : this.y;
let text = value != null && value !== ''
  ? Number(value).toFixed(2)
  : value;
                let text1:any;
                if(text!=null){
                    text1= parseFloat(Number(text).toFixed(properties.decimalRoundOff));
                }
                else{
                  text1=text;
                }
                const dotColor = this.series.color; // Get the series color
                const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
                const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
                
                // Extract change value
                let changeText = this.series.userOptions.changeValue[this.point.x];
                let changeColor = 'black';
                if (changeText != null && changeText !== 'NA') {
                  changeText = parseFloat(changeText);
                  changeColor = changeText > 0 ? 'green' : (changeText < 0 ? 'red' : 'black');
                  if (changeText > 0) {
                    changeText = '+' + changeText.toFixed(2);
                  } else if (changeText < 0) {
                    changeText = changeText.toFixed(2);
                  } else {
                    changeText = '0';
                  }
                }
                
                // Extract significance value
                let sig = this.series.userOptions.significanceValue[this.point.x];
                const upwardTriangle = '▲';
                const downwardTriangle = '▼';
                let sigSymbol = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let sigColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : 'black');
                
                if (isDefaultTooltip != "style1") {
                  // const commonContent =
                  //   `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  //   `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                  //   `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
                  //   `<span><strong>Category Name:</strong></span> ${this.point.category}<br>` +
                  //   `<span><strong>Value:</strong></span> ${text1}`;
                  // return commonContent + '</div>';
                  let changeValueDisplay = changeText != null && changeText !== 'NA' ? `<br><span style="color: ${changeColor}; font-size: 0.9em;">Change: (${changeText})</span>` : '';
                  let sigDisplay = sigSymbol ? `<span style="color: ${sigColor}; margin-left: 4px;">${sigSymbol}</span>` : '';
                  
                  const commonContent =
                  `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px;font-size: 0.8em; margin: 0; background-color: ${backgroundcolor2}; width:110%">` +
                  `<span style="display: none; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                  ` ${this.series.name}<br>` +
                  `${this.point.category} : ` +
                  ` ${text1}${sigDisplay}` +
                  `${changeValueDisplay}`;
                   return commonContent + '</div>';
                }
                else {
                  let changeValueDisplay = changeText != null && changeText !== 'NA' ? `<br><span style="color: ${changeColor}; font-size: 0.6em; margin-left: 4px;">Change: (${changeText})</span>` : '';
                  let sigDisplay = sigSymbol ? `<span style="color: ${sigColor}; margin-left: 4px; font-size: 0.8em;">${sigSymbol}</span>` : '';
                  
                 const content =
    `<div class="high-z-tooltip" style="background: #fff;border:1px solid ${dotColor};border-radius:4px; min-width: 220px; font-size: 0.7em; box-shadow: none; padding:8px; z-index:999 !important;">
      <div style="display: flex; align-items: center; margin-bottom: 4px;">
        <span style="width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
        <span><strong>${this.series.name}</strong></span>
      </div>
      <div style="margin-left: 18px;">
        <div>${this.point.category}: <b style="color: ${dotColor};">${text1}</b> ${sigDisplay}</div>
        ${changeValueDisplay}
      </div>
    </div>`;
  return content;
                }
              }
          },
            plotOptions: {
              series:{
                animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
              },
              line: {
                dashStyle: this.ChartProperties.Linestyle,
                shadow: this.ChartProperties.shadow ? {
                  color: this.ChartProperties.darkTheme? 'rgba(255,255,255,0.5)':'rgba(0, 0, 0, 0.5)',
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 5,
                } : false,
                marker: {
                  symbol: properties.markerStyle,
                },
                dataLabels:
                {
                  allowOverlap: this.ChartProperties.allowOverlap,
                  enabled: this.ChartProperties.showDataLabel,
                  align: this.ChartProperties.dataLabelPosition,
                  rotation: this.ChartProperties.datalabelOrientation,
                  color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.spiderService.darkThemeTextColor : this.spiderService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
                  style: {
                    backgroundColor: 'transparent',
                    shadow: false,
                    borderWidth: 0,
                    textOutline: 'none',
                    borderRadius: 0,
                    padding: '2%',
                    fontFamily: this.spiderService.textfont,
                    fontSize: this.ChartProperties.dataLabelSize,
                    fontWeight: "normal"
                  },
                  formatter: function (this: any) {
                    let sigcolor;
                    const upwardTriangle = '&#9650';
                    const downwardTriangle = '\u25BC';
                    const upColor = 'green';
                    const downColor = 'red';
                    let text; let finalText;
                    let changeText;
                    let sig;
                    let sColor;

                    if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                      finalText = "NA";
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }
                    if (properties.datalabelStyle == "sigchan") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = properties.darkTheme ? 'white' : 'black';

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }


                    if (properties.datalabelStyle == "datalabel") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      finalText = (
                        '<span >' + text + '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "change") {
                      text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      let changeColor = properties.darkTheme ? 'white' : 'black';

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }
                      
                      finalText = (
                        '<span>' + text +
                        (changeText ? '&nbsp<span style="color:' + ';">' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "significance") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                      finalText = (
                        '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == "significance2") {
                      text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA';
                      changeText = this.series.userOptions.changeValue[this.point.x];
                      sig = this.series.userOptions.significanceValue[this.point.x];
                      let sig1 = this.series.userOptions.significanceValue2[this.point.x];
                      sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                      let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                      let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                      if (parseFloat(changeText) > 0) {
                        changeText = "+" + changeText;
                      }

                      finalText = (
                        '<span>' + text +
                        (this.y != 0 && changeText ? '&nbsp<span style="color:' + ';"> ' +
                          '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                          '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                        '</span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    if (properties.datalabelStyle == 'lowSample') {
                      text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';
                      finalText = (
                        '<span>' +
                        text +
                        '</span> ' +
                        '<span style="opacity: 0.5"></span>'
                      );
                      this.series.userOptions.tooltip[this.point.x]=finalText;
                      return finalText;
                    }

                    finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                    this.series.userOptions.tooltip[this.point.x]=finalText;
                    return finalText;
                  }
                }
              }
            },
            series: this.seriesData,
          } as any;
          const containerEl = document.getElementById(container2);
          if (!containerEl) { return; }
          this.chart = Highcharts.chart(containerEl, options);
    }
  }

  commonfunc(event: any, customization: string) {
    this.event = event;
    this.spiderService.commonFunc2(customization, event, this.ChartProperties)
    this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
  }

  customization(): Observable<any> {
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    // return this.piechartservice.PieChart1to10customizationList();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Spider/ Radar", snapshotTypeSelectedName, cohortType));
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.spiderService.applycustomization(event, item, this.ChartProperties)
    this.renderChart2('chart-container'+ this.id, this.data['data'], this.ChartProperties);
  }


  userselectedproperties() {
    this.data["properties"][0] = this.ChartProperties;
    this.data["data"] = this.ChartData;
    return JSON.stringify(this.data).toString();
  }

  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
